// @ts-check
import { useHistory } from "react-router-dom";
import { useTemplateDataGridContext } from '~/components/Forms/TemplateDataGrid/TemplateDataGrid.context';
import { EventNames } from '~/components/Forms/TemplateDataGrid/TemplateDataGrid.utils';
import useOrganizationId from '~/hooks/useOrganizationId';
import ConfirmModal from '~/components/Shared/ConfirmModal';
import FormOptionsModal from '~/components/AdminPages/ManageForms/FormOptionsModal';
import SchedulesListModal from '~/components/Shared/SchedulesListModal';
import NotificationAlert from '~/other/NotificationAlert';
import { useZeroContext } from '~/components/ZeroContext';
import { delete_form } from '~/api/zero-api';
import { FormType } from '~/other/Constants';

export function TemplateDataGridModals({ showCreateModal, onCloseCreateModal, pageType }) {
    const history = useHistory();
    const { events } = useZeroContext();
    const { activeModal, setActiveModal, gridRef } = useTemplateDataGridContext();
    const orgId = useOrganizationId();

    if (showCreateModal) {
        return (
            <FormOptionsModal
                show
                cancel={onCloseCreateModal}
                complete={onCloseCreateModal}
                form_to_edit={null}
                team_access={false}
                forceFormType={
                    pageType === "lms" ? FormType.LMS : pageType === "incident" ? FormType.INCIDENT : null
                }
                refresh={() => events.emit(EventNames.REFRESH_DATA)}
            />
        );
    }

    if (!activeModal) {
        return null;
    }

    const { key, form } = activeModal;
    const closeModal = () => setActiveModal(null);
    const refreshDataGrid = () => events.emit(EventNames.REFRESH_DATA);

    switch (key) {
        case "edit_template":
            return (
                <FormOptionsModal
                    show
                    cancel={closeModal}
                    complete={closeModal}
                    form_to_edit={form}
                    team_access={false}
                    forceFormType={
                        pageType === "lms" ? FormType.LMS : pageType === "incident" ? FormType.INCIDENT : null
                    }
                    refresh={refreshDataGrid}
                />
            );
        case "teams":
            return (
                <FormOptionsModal
                    show
                    cancel={closeModal}
                    complete={closeModal}
                    form_to_edit={form}
                    team_access={true}
                    refresh={refreshDataGrid}
                />
            );
        case "schedules":
            return (
                <SchedulesListModal
                    show
                    cancel={closeModal}
                    form={form}
                    goToSchedule={(scheduleId) =>
                        history.push(`/${orgId}/home/manage_schedules/analytics/${scheduleId}`)
                    }
                />
            );
        default:
            console.error(`Unknown template table modal '${key}'`);
    }

    return null;
}
